// extracted by mini-css-extract-plugin
module.exports = {"bannerTextWidth":"coursesPage_bannerTextWidth__3fIyw","pusherDiv":"coursesPage_pusherDiv__2eCil"};